import * as React from 'react';
import { SelectListItem, Tooltip } from 'kui';
import { IDependencyAddProps } from './types';
import { LIST_LABEL } from 'app/const';
import { escape } from 'underscore';

export function DependencyAdd ({
    img,
    text,
    textSub,
    value,
}: IDependencyAddProps) {
    return (
        <SelectListItem
            key={value}
            icon={img}
            list={textSub}
            listLabel={LIST_LABEL + escape(textSub)}
            value={value}
        >
            <Tooltip
                isNoWrap={true}
                value={escape(text)}
            >
                <span>{text}</span>
            </Tooltip>
        </SelectListItem>
    );
};
